// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2g8Z-","selects":"Documents_selects__3mxBP"};